var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.088 7.53602C17.088 6.38402 16.128 5.47202 15.024 5.47202H8.92801C7.77601 5.47202 6.86401 6.38402 6.86401 7.53602V14.016H17.136V7.53602H17.088Z",
    fill: "#ACFCAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76001 15.84V16.032C5.76001 16.512 6.14401 16.896 6.62401 16.896H17.328C17.808 16.896 18.192 16.512 18.192 16.032V15.84C18.192 15.36 17.808 14.976 17.328 14.976H6.62401C6.14401 14.976 5.76001 15.36 5.76001 15.84Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.48 17.808H5.37599C4.89599 17.808 4.51199 18.192 4.51199 18.672V18.864C4.51199 19.344 4.89599 19.728 5.37599 19.728H18.48C18.96 19.728 19.344 19.344 19.344 18.864V18.672C19.344 18.192 18.912 17.808 18.48 17.808Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartBtnIcon);
export default __webpack_public_path__ + "static/media/start-btn-icon.55402f9729a879b9b74e6393c987b625.svg";
export { ForwardRef as ReactComponent };